import BaseProxy from "../../../base-proxy";

/**
 * @class ResignationOfDirectorStartProxy
 * @description KYC workflow endpoints
 * @author Aldrev Ven Dayrit
 * @version 1.0
 * @since
 */
export default {
  /**
   * @async
   * @function execute
   * @param input Input parameter.
   * @param {String} input.companyId Responding company's ID
   * @param {String} input.companyName Responding company's name
   * @param {String} input.companyUserId Responding company user's ID.
   * @param {String} input.companyUserName Responding company user's Name.
   * @param {String} input.address1 Responding company address 1
   * @param {String} input.address2 Responding company address 2
   * @param {String} input.city Responding company city
   * @param {String} input.postcode Responding company postcode
   * @param {String} input.authToken Token used for issuing authenticated request.
   * @param {Object} input.payload payload form
   */
  async postChangeAddressStart(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/v2/workflow/api/tasks/change-of-address/start`;

    return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, input.payload);
  },
};
